import { Component, Inject, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-common-msg',
  templateUrl: './common-msg.component.html',
  styleUrls: ['./common-msg.component.scss']
})
export class CommonMsgComponent implements OnInit {
  pdfUrl: any;
  uniqueName: string;
  objectData: any;
  pdfUrlWhatsapp: any;
  displayedColumns: string[] = ['date','txnType','amount', 'narration'];
  dataSource = [];
  ymLogoPng: string;
 
  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<CommonMsgComponent>,
    private authservice:AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ymLogoPng=environment.ym_logo_png;

    this.uniqueName=localStorage.getItem('uniqueName');
   }
 
  ngOnInit(): void {
    console.log('data', this.data);
    this.objectData=this.data.object;
    if(this.data.object && this.data.object.miniStatementStructureModel){
      this.dataSource=this.data.object.miniStatementStructureModel;

    }
    console.log('dataSource', this.dataSource);
    if(this.objectData.transactionType=='BE'){
      if(this.objectData && this.objectData.transactionReference){
         this.downloadPdf(this.objectData.transactionReference,'whatsapp');
        
      }
      this.downloadPdf(this.objectData.ymTransactionReferance,'whatsapp');
     

    }else if(this.objectData.cashwithdrawlDetails.transactionType=='CW' || this.objectData.cashwithdrawlDetails.transactionType=='M'){
      this.downloadPdf(this.objectData.transactionReference,'whatsapp');
    
    }else{

      this.downloadPdf(this.data.transactionReference ||this.objectData.transactionReference,'whatsapp');

    }
  
    
  }
  cancel(){
    this.dialogRef.close();
    this.data.receipt_link="";
    this.data="";
    this.router.navigate['/dashboard'];

 
  }
  proceed(){
    this.dialogRef.close();
  }
  
 
   downloadPdf(transactionReference,value){
  
    this.authservice.downloadPdf(transactionReference).subscribe((res:any)=>{
      if(res.status_code==1){
        if(value == 'whatsapp'){
          this.pdfUrlWhatsapp=res.receiptURl;
            }else{
       
        window.open(res.receiptURl);
            }
      }
  
    })
  
   }
   downloadPdfMS(receiptURl,value){
    if(value == 'whatsapp'){
      this.pdfUrlWhatsapp=receiptURl;
        }else{
          window.open(receiptURl);

        }
  
  
   }
   ngOnDestroy(){
    this.data="";
    this.dialogRef.close();
    // this.data.receipt_link="";
    this.router.navigate['/dashboard'];
    
   }
}
